// import React, { useEffect, useState } from "react";
// import EventImg from "../../../../assets/img/event.jpg";
// import useApiRequest from "../../../../Hooks/apiReq";
// import { useNavigate } from "react-router-dom";
// import SpinnerLoader from "../../../../CommonComponets/SpinnerLoader";
// import { useSelector } from "react-redux";
// import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import { TbGridDots } from "react-icons/tb";
// import PreviewImage from "../../../../ExternalLib/PreviewImage/PreviewImage.jsx";

// const UpdatedNews = () => {
//   const { loading, sendApiRequest } = useApiRequest();
//   const [data, setData] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const navigate = useNavigate();
//   const appType = useSelector((state) => state?.uiReducers?.appType);

//   const getUpdatedEventlist = () => {
//     sendApiRequest("POST", "/Dashboard/GetEventList", "", {
//       onSuccess: (res) => {
//         const ParsedData = res?.data?.jsonData
//           ? JSON.parse(res?.data?.jsonData)
//           : [];
//         setData(ParsedData);
//       },
//       onStatus3: () => navigate("/login"),
//     });
//   };

//   useEffect(() => {
//     if (appType === "Business") getUpdatedEventlist();
//   }, []);

//   const handlePrev = () =>
//     setCurrentIndex((prev) => (prev > 0 ? prev - 1 : data.length - 1));
//   const handleNext = () =>
//     setCurrentIndex((prev) => (prev < data.length - 1 ? prev + 1 : 0));

//   const currentItem = data[currentIndex];
//   // Extract year dynamically or fallback to 2025
//   const currentYear = currentItem?.EventDateName?.split(" ").pop() || "2025";

//   return (
//     <div className="col-12 col-xl-4 col-xxl-3">
//       {loading && <SpinnerLoader />}
//       <div className="card border-0 h-100 w-100 overflow-hidden shadow-sm">
//         <div className="card-body p-3 text-center">
//           {/* Header Section */}
//           <div className="d-flex align-items-center mb-3">
//             <div
//               className="me-2 fw-bold  d-flex align-items-center gap-2"
//               style={{ fontSize: "1rem" }}
//             >
//               <TbGridDots className="" /> Event Calendar {currentYear}
//             </div>
//           </div>

//           {/* Navigation Bar with Dashed Style */}
//           <div className="d-flex justify-content-between align-items-center mb-4 px-1">
//             <button
//               onClick={handlePrev}
//               className="btn btn-nav-dashed"
//               disabled={currentIndex === 0}
//               aria-label="Previous"
//             >
//               <FaChevronLeft size={14} />
//             </button>

//             <div className="date-display-badge">
//               {currentItem?.EventDateName || "Select Date"}
//             </div>

//             <button
//               onClick={handleNext}
//               className="btn btn-nav-dashed"
//               aria-label="Next"
//               disabled={data.length === currentIndex + 1}
//             >
//               <FaChevronRight size={14} />
//             </button>
//           </div>

//           {/* Event Content Section */}
//           {data?.length > 0 ? (
//             <div className="event-content animate-fade-in">
//               <div className="mb-3 d-flex justify-content-center">
//                 {/* <img
//                   className="rounded-3 object-fit-cover shadow-sm border"
//                   src={currentItem?.EventImg || EventImg}
//                   alt="Event"
//                   style={{ width: "160px", height: "160px" }}
//                 /> */}
//                 <PreviewImage
//                   imgwithUrl={currentItem?.EventImg || EventImg}
//                   style={{ width: "160px", height: "120px" }}
//                 />
//               </div>
//               <h4
//                 className="fw-bolder   mb-1 px-2"
//                 style={{ fontSize: "1.15rem" }}
//               >
//                 {currentItem?.Title || currentItem?.News}
//               </h4>

//               <p className=" fs-9 px-3 mt-2 lh-base">
//                 {currentItem?.Descr ||
//                   "No description available for this event."}
//               </p>
//               <button
//                 className="btn btn-sm btn-outline-danger w-100 rounded-pill"
//                 onClick={() => navigate("/event-registration")}
//               >
//                 Register Now
//               </button>
//             </div>
//           ) : (
//             <div className="py-5 text-muted">No upcoming events.</div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UpdatedNews;

import React, { useEffect, useState } from "react";
import EventImg from "../../../../assets/img/event.jpg";
import useApiRequest from "../../../../Hooks/apiReq";
import { useNavigate } from "react-router-dom";
import SpinnerLoader from "../../../../CommonComponets/SpinnerLoader";
import { useSelector } from "react-redux";
import { TbGridDots } from "react-icons/tb";
import PreviewImage from "../../../../ExternalLib/PreviewImage/PreviewImage.jsx";
import Slider from "../../../../ExternalLib/Carousel/Carousel.jsx";
const UpdatedNews = () => {
  const { loading, sendApiRequest } = useApiRequest();
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const appType = useSelector((state) => state?.uiReducers?.appType);

  const getUpdatedEventlist = () => {
    sendApiRequest(
      "POST",
      "/Dashboard/GetEventList",
      {
        Mode: "EVENT",
      },
      {
        onSuccess: (res) => {
          const ParsedData = res?.data?.jsonData
            ? JSON.parse(res?.data?.jsonData)
            : [];
          setData(ParsedData);
        },
        onStatus3: () => navigate("/login"),
      },
    );
  };

  useEffect(() => {
    if (appType === "Business") getUpdatedEventlist();
  }, []);

  return (
    <div className="col-12 col-xl-4 col-xxl-3">
      <div
        className="card border-0 shadow-sm overflow-hidden"
        style={{ borderRadius: "12px" }}
      >
        {loading && <SpinnerLoader />}

        {/* Header stays static */}
        <div className="card-header bg-white border-0 pt-3 px-3">
          <div
            className="d-flex align-items-center gap-2 fw-bold text-dark"
            style={{ fontSize: "1.1rem" }}
          >
            <TbGridDots size={20} /> Event Calendar 2026
          </div>
        </div>

        <div className="card-body p-0">
          {/* Scrollable Wrapper */}
          <div className="event-scroll-container">
            {data?.length > 0 ? (
              data.map((item, index) => (
                <>
                  <Slider>
                    <div key={index} className="event-slide">
                      {/* Date Badge */}
                      <div className="d-flex justify-content-center my-3">
                        <div className="bg-dark text-white px-4 py-2 rounded-3 fw-bold shadow-sm">
                          {item?.EventDateName || "TBA"}
                        </div>
                      </div>

                      {/* Image */}
                      <div className="px-4 mb-3 text-center">
                        <PreviewImage
                          imgwithUrl={item?.EventImg || EventImg}
                          className="rounded-3 shadow-sm border"
                          style={{
                            width: "100%",
                            height: "180px",
                            objectFit: "cover",
                          }}
                        />
                      </div>

                      {/* Text Content */}
                      <div className="text-center px-4 pb-3">
                        <h5 className="fw-bold mb-1">
                          {item?.Title || item?.News}
                        </h5>
                        <p className="text-muted small mb-4">
                          {item?.Descr || "Annual Success Celebration"}
                        </p>

                        <button
                          className="btn btn-outline-danger  w-100 rounded-pill   fw-bold"
                          onClick={() => navigate("/event-registration")}
                          style={{ borderWidth: "1.5px" }}
                        >
                          Register Now
                        </button>
                      </div>
                    </div>
                  </Slider>
                </>
              ))
            ) : (
              <div className="py-5 text-center text-muted">
                No events scheduled.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdatedNews;
